import React from 'react';
import { includes } from 'lodash';
import CountUp from 'react-countup';
import ReactVisibilitySensor from 'react-visibility-sensor';
import Slider from 'react-slick';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { StatInfo, Span, NumP } from './styles/StatInfo.styled';
import { DWTCContext } from '../utils/context';

export default function Statistics({ data, id, dir }) {
  const { cssClass } = React.useContext(DWTCContext);

  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: false,
    autoplay: false,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 1,
          infinite: true,
          autoplay: false,
          dots: true,
        },
      },
    ],
  };

  const [toggleState, setToggleState] = React.useState(false);

  const handleVisibilityChange = (isVisible) => {
    if (isVisible) setToggleState(true);
  };

  return (
    <StatInfo id={id} color={getTheme()} dir={dir}>
      <Container>
        <Row>
          <ul className="figures" dir={dir}>
            <Slider {...settings}>
              {data.items.map(({ content: { title, byline, value, unit } }, index) => (
                <div className="list-container" key={index}>
                  <NumP className="num" dir={dir}>
                    <CountUp
                      start={toggleState ? 0 : value}
                      end={value}
                      delay={0}
                      decimal="."
                      decimals={parseFloat(value) % 1 !== 0 ? 1 : 0}
                    >
                      {({ countUpRef }) => (
                        <ReactVisibilitySensor onChange={handleVisibilityChange} delayedCall>
                          <Span ref={countUpRef} dir={dir} />
                        </ReactVisibilitySensor>
                      )}
                    </CountUp>
                    {unit}
                  </NumP>
                  <NumP className="numtxt" dir={dir}>
                    {title}
                    <small>{byline}</small>
                  </NumP>
                </div>
              ))}
            </Slider>
          </ul>
        </Row>
      </Container>
    </StatInfo>
  );
}
